import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllVanitylinksTable from './Table';
import AdminPageHead from '../../Common/PageHead';
import NewVanityLinkModal from '../../Modals/VanityLink/NewVanityLinkModal';
import style from './styles/style.module.css';

class AllVanityLinksView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            vanityLinks: [],
            vanityQueryObject: {
                sort: 'vanity_url_path',
            },
            newModal: false,
        };

        this.loadVanityLinks();
    }
    onColumnSort = ( value ) => {
        if( this.state.vanityQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.vanityLinks = [];
            prevState.vanityQueryObject.page = 1;
            prevState.vanityQueryObject.sort = value || undefined;
            return prevState;
        } );
        this.loadVanityLinks();
    }
    onSearch = ( value ) => {
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.vanityLinks = [];
            prevState.vanityQueryObject.page = 1;
            prevState.vanityQueryObject.search = value || undefined;
            return prevState;
        } );
        this.loadVanityLinks();
    }
    loadVanityLinks = () => {
        return this.props.getVanityLinks( this.state.vanityQueryObject )
        .then( ( vanityLinks ) => {
            this.setState( ( prevState ) => {
                prevState.fetching= false,
                prevState.vanityLinks = prevState.vanityLinks.concat( vanityLinks ),
                prevState.vanityQueryObject.page++;
                return prevState;
            } );
            return vanityLinks;
        } );
    }
    vanityLinkUpdated = ( index, vanityLink ) => {
        this.setState( ( altState ) => {
            if( vanityLink !== null ) {
                altState.vanityLinks[ index ] = vanityLink;
                altState.vanityLinks = altState.vanityLinks.slice( 0 );
            } else {
                altState.vanityLinks = altState.vanityLinks.slice( 0, index ).concat( altState.vanityLinks.slice( index +1 ) );
            }
            return altState;
        } );
    }
    openNewModal = () => {
        this.setState( { newModal: true } );
    }
    onNewModalClose = () => {
        this.setState( { newModal: false } );
    }
    onNewModalSubmit = ( newVanityLink ) => {
        this.setState( ( altState ) => {
            altState.vanityLinks.unshift( newVanityLink );
            altState.vanityLinks = altState.vanityLinks.slice( 0 );
            altState.newModal = false;
            return altState;
        } );
    }

    render() {
        const { fetching, vanityLinks } = this.state;

        return (
            <section className={ style.page }>
                <AdminPageHead title='Vanity URLs'
                onSearch={ this.onSearch }
                tabs={ [
                    { label: 'View All', to: '/admin/vanity-links' },
                ] }
                buttons={ [
                    { label: '+ Add New', onClick: this.openNewModal },
                ] } />
                <div className={ style.body }>
                    <section className={ style.allList }>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllVanitylinksTable
                            vanityLinks={ vanityLinks }
                            onColumnSort={ this.onColumnSort }
                            currentSort={ this.state.vanityQueryObject.sort }
                            onVanityLinkUpdated={ this.vanityLinkUpdated }
                            elementHeight={ 70 } />
                        }
                    </section>
                </div>
                { this.state.newModal &&
                    <NewVanityLinkModal closeModal={ this.onNewModalClose }
                    onSubmit={ this.onNewModalSubmit } />
                }
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getVanityLinks: ( queryObject ) => {
            return dAPI.get( '/admin/vanity-urls', queryObject );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllVanityLinksView );
